<template>
  <v-app>
    <v-system-bar :color="headerColor" app>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="10"
          offset-md="1"
          lg="10"
          offset-lg="1"
          xl="8"
          offset-xl="2"
        >
          <div class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp">
            <div class="flex-grow-1">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn small text v-on="on">
                    <v-icon left color="white" class="small-icon"
                      >far fa-globe</v-icon
                    >
                    <span class="white-text text-normal">{{
                      currentLocale
                    }}</span>
                    <v-icon small right color="white">fas fa-caret-down</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item-group>
                    <v-list-item color="pink-text" @click="changeLocale('en')"
                      >English</v-list-item
                    >
                    <v-list-item color="pink-text" @click="changeLocale('th')"
                      >ภาษาไทย</v-list-item
                    >
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
            <div>
              <span class="caption text-primary">{{ contact }}</span>
            </div>
            <div class="mx-2 white-text">|</div>
            <div>
              <a
                target="_blank"
                href="https://nerdof.com/termOfUse"
                class="caption text-primary"
                >Term of use</a
              >
            </div>
            <div class="mx-2 white-text">|</div>
            <div>
              <a
                target="_blank"
                href="https://nerdof.com/privacy"
                class="caption text-primary"
                >Privacy</a
              >
            </div>
            <div class="mx-2 white-text">|</div>
            <div>
              <a
                target="_blank"
                href="https://nerdof.com/policy"
                class="caption text-primary"
                >Policy</a
              >
            </div>
            <div class="mx-2 white-text">|</div>
            <div>
              <a class="caption text-primary" href>About Us</a>
            </div>
          </div>
          <div class="d-flex align-center" v-else>
            <div class="flex-grow-1">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn small text v-on="on">
                    <v-icon left color="white" class="small-icon"
                      >far fa-globe</v-icon
                    >
                    <span class="white-text text-normal">{{
                      currentLocale
                    }}</span>
                    <v-icon small right color="white">fas fa-caret-down</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item-group>
                    <v-list-item color="pink-text" @click="changeLocale('en')"
                      >English</v-list-item
                    >
                    <v-list-item color="pink-text" @click="changeLocale('th')"
                      >ภาษาไทย</v-list-item
                    >
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
            <div>
              <span class="caption text-primary">{{ contact }}</span>
            </div>
            <v-menu left bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon color="white">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item-group>
                  <v-list-item>
                    <a
                      target="_blank"
                      href="https://nerdof.com/termOfUse"
                      class="black-text"
                      >Term of use</a
                    >
                  </v-list-item>
                  <v-list-item>
                    <a
                      target="_blank"
                      href="https://nerdof.com/privacy"
                      class="black-text"
                      >Privacy</a
                    >
                  </v-list-item>
                  <v-list-item>
                    <a
                      target="_blank"
                      href="https://nerdof.com/policy"
                      class="black-text"
                      >Policy</a
                    >
                  </v-list-item>
                  <v-list-item>
                    <a class="black-text" href>About Us</a>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </v-system-bar>
    <v-app-bar color="white" elevation="2" app :dense="false">
      <v-row class="fill-height flex-nowrap max-width" no-gutters>
        <v-col
          style="max-height: 100%"
          cols="12"
          md="10"
          offset-md="1"
          lg="10"
          offset-lg="1"
          xl="8"
          offset-xl="2"
        >
          <div class="d-flex fill-height" style="max-height: 100%">
            <template v-if="$vuetify.breakpoint.lgAndUp">
              <!-- <div class="flex-grow-1"> -->
              <v-col cols="12" md="4" lg="4" xl="4" class="no-padding">
                <img
                  @click="logoClick"
                  class="hoverable"
                  style="
                    max-height: 100%;
                    width: auto;
                    max-width: 100% !important;
                  "
                  :src="logo"
                  alt
                />
              </v-col>
              <!-- </div> -->
            </template>
            <template v-else>
              <!-- <div class="flex-grow-1 align-self-center">
                <div @click="logoClick" class="hoverable primary--text text-overflow">{{ title }}</div>
              </div>-->
              <v-col cols="9" md="4" lg="9" xl="9" class="no-padding">
                <img
                  @click="logoClick"
                  class="hoverable"
                  style="
                    max-height: 100%;
                    width: auto;
                    max-width: 100% !important;
                  "
                  :src="logo"
                  alt
                />
              </v-col>
            </template>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <!-- <div class="flex-grow-1 align-self-center mr-2"> -->
              <v-col
                cols="12"
                md="4"
                lg="4"
                xl="4"
                class="no-padding align-self-center mr-2"
              >
                <v-form @submit.prevent="onSearch" ref="formSearch">
                  <v-text-field
                    class="search"
                    hide-details
                    outlined
                    dense
                    single-line
                    placeholder="Search"
                    prepend-inner-icon="far fa-search"
                    clearable
                    @click:clear="clearSearch"
                    v-model="mainSearch"
                  ></v-text-field>
                </v-form>
                <!-- </div> -->
              </v-col>
            </template>
            <template v-else>
              <!-- <div class="flex-shrink-1 align-self-center"> -->
              <v-col
                cols="1"
                md="1"
                lg="1"
                xl="1"
                class="no-padding align-self-center mr-4"
              >
                <v-btn class="ml-2" icon @click="mobileSearch = !mobileSearch">
                  <v-icon>far fa-search</v-icon>
                </v-btn>
              </v-col>
              <!-- </div> -->
            </template>
            <v-col
              cols="1"
              md="4"
              lg="4"
              xl="4"
              class="no-padding align-self-center mr-2 text-right"
            >
              <!-- <div class="flex-shrink-1 align-self-center"> -->
              <v-menu offset-y bottom right nudge-bottom="0">
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    v-on="on"
                    :icon="$vuetify.breakpoint.smAndDown"
                    v-if="avatar"
                  >
                    <v-avatar
                      size="32"
                      :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }"
                    >
                      <v-img :src="avatar"></v-img>
                    </v-avatar>
                    <template v-if="$vuetify.breakpoint.mdAndUp && displayName">
                      <span class="text-capitalize">{{ displayName }}</span>
                      <v-icon right x-small>fas fa-caret-down</v-icon>
                    </template>
                  </v-btn>
                  <div v-on="on" v-else>
                    <v-avatar v-if="$vuetify.breakpoint.smAndDown" size="32">
                      <v-icon color="black">mdi-menu</v-icon>
                    </v-avatar>
                    <div v-else>
                      <v-btn text :to="{ name: 'login' }">Sign in</v-btn>
                      <v-btn text v-if="canRegister" :to="{ name: 'register' }"
                        >Register</v-btn
                      >
                    </div>
                  </div>
                </template>

                <v-list dense class="list-menu" v-if="avatar">
                  <v-list-item link :to="{ name: 'my_course' }">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">far fa-books</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>My Course</v-list-item-title>
                  </v-list-item>
                  <v-list-item link :to="{ name: 'wishlist' }">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">far fa-heart</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Wish List</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item link :to="{ name: 'my_identity' }">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">far fa-address-card</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>My Identity</v-list-item-title>
                  </v-list-item>
                  <v-list-item link :to="{ name: 'profile' }">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">far fa-address-card</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Profile</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item link :to="{ name: 'portfolio' }">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">far fa-images</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Portfolio 55</v-list-item-title>
                  </v-list-item> -->

                  <v-list-item link @click="logout">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">far fa-sign-out</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Sign out</v-list-item-title>
                  </v-list-item>
                </v-list>

                <v-list dense class="list-menu" v-else>
                  <v-list-item link :to="{ name: 'login' }">
                    <v-list-item-icon>
                      <v-icon class="fa-fw">fas fa-sign-in</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Sign in</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    link
                    :to="{ name: 'register' }"
                    v-if="canRegister"
                  >
                    <v-list-item-icon>
                      <v-icon class="fa-fw">fas fa-user-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Register</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </div>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-content>
      <router-view :key="$route.fullPath"></router-view>
    </v-content>
    <v-dialog v-model="mobileSearch" light id="dialogMobileSearch">
      <v-card color="white">
        <div class="pa-4 pb-0">
          <div class="title mb-2">Search</div>
          <v-form
            class="mobile-search"
            @submit.prevent="onSearch"
            ref="formMobileSearch"
          >
            <v-text-field
              autofocus
              hide-details
              outlined
              dense
              single-line
              placeholder="Search"
              prepend-inner-icon="far fa-search"
              v-model="mainSearch"
            ></v-text-field>
          </v-form>
        </div>
        <v-card-actions>
          <v-btn text @click="cancelSearchMobile">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn text :color="$buttonColor" @click="onSearch">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { EventBus } from "@/event-bus";
export default {
  data: () => ({
    cartCount: 0,
    drawer: false,
    items: [
      { title: "ภาพรวม", icon: "far fa-analytics", to: { path: "/" } },
      {
        title: "นำเข้าข้อมูลงาน",
        icon: "far fa-file-excel",
        to: { name: "import" },
      },
      {
        title: "จัดการสถานะงาน",
        icon: "far fa-ballot-check",
        to: { name: "jobs" },
      },
      {
        title: "รายงาน",
        icon: "far fa-file-chart-line",
        to: { name: "report" },
      },
    ],
    masterMenu: [
      { title: "ผู้ใช้งาน", icon: "far fa-users", to: { name: "users" } },
      { title: "ลูกค้า", icon: "far fa-building", to: { name: "customer" } },
      { title: "รถ", icon: "far fa-cars", to: { name: "cars" } },
      { title: "คนขับ", icon: "fal fa-person-carry", to: { name: "driver" } },
    ],
    title: "",
    displayName: "",
    avatar: null,
    logo: null,
    contact: "",
    mobileSearch: false,
    mainSearch: "",
  }),
  computed: {
    currentLocale() {
      return this.$vuetify.lang.current;
    },
    headerColor() {
      return Vue.prototype.$userInfo.companies[0].headerColor;
    },
    canRegister() {
      return Vue.prototype.$userInfo.companies[0].canRegister;
    }
    // displayName() {
    //   const info = Vue.prototype.$userInfo;
    //   if (info != null) {
    //     return `${info.firstName} ${info.lastName}`;
    //   }
    //   return "";
    // }
  },
  beforeDestroy() {
    EventBus.$off("updateNavBar");
    EventBus.$off("resetNavBar");
    EventBus.$off("updateProfile");
  },
  mounted() {
    // console.log("Main")
    const info = Vue.prototype.$userInfo;
    // console.log(info);

    if (info != null) {
      // console.log(info.companies)
      // this.logo = info.companies[0].logo;
      this.logo = info.companies[0].coverImg;
      this.title = info.companies[0].title;
      this.contact = info.companies[0].contactEmail;
      this.displayName = info.displayName;
      this.avatar = info.image;
    }
    if (this.$vuetify.breakpoint.lgAndUp) {
      this.drawer = true;
    }
    const theme = localStorage.getItem("theme");
    if (theme != null) {
      this.$vuetify.theme.themes.light.primary = theme;
    }

    this.getProfile();

    //#region binding event
    EventBus.$on("updateNavBar", (data) => {
      this.updateNavBar(data);
    });
    EventBus.$on("resetNavBar", (data) => {
      this.resetNavBar();
    });
    EventBus.$on("updateProfile", (data) => {
      this.getProfile();
    });
    //#endregion
  },
  updated() {
    let search = this.$route.query.search || null;
    if (search != null) {
      this.mainSearch = search;
    }
  },
  watch: {
    title(val) {
      if (val != "") {
        document.title = val;
      }
    },
    // mobileSearch(val) {
    //   if (!val) {
    //     this.mainSearch = "";
    //   }
    // }
  },
  methods: {
    getProfile() {
      // console.log("Main")
      const info = Vue.prototype.$userInfo;
      // console.log(info);

      if (info != null) {
        // console.log(info.companies)
        // this.logo = info.companies[0].logo;
        this.logo = info.companies[0].coverImg;
        this.title = info.companies[0].title;
        this.contact = info.companies[0].contactEmail;
        this.displayName = info.displayName;
        this.avatar = info.image;
      }
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.drawer = true;
      }
      const theme = localStorage.getItem("theme");
      if (theme != null) {
        this.$vuetify.theme.themes.light.primary = theme;
      }
    },
    cancelSearchMobile() {
      this.mobileSearch = false;
      this.clearSearch();
    },
    clearSearch() {
      if (this.$route.name == "course") {
        let qs = this.$utility.vueRouterQueryToJson(this.$route.query);
        delete qs.search;
        this.$nextTick(() => {
          this.$router
            .replace({
              query: qs,
            })
            .then(() => {
              this.mainSearch = "";
            })
            .catch(() => {
              // do nothing
              // window.location = "/course?" + this.$utility.routerQueryStringToUrlParams(qs);
            });
        });
      }
    },
    changeLocale(locale) {
      EventBus.$emit("changeLocale", locale);
    },
    logoClick() {
      if (this.$route.name != "home") {
        this.$router.push({
          name: "home",
        });
      }
    },
    updateNavBar(data) {
      this.title = data.title;
      // this.displayName = data.systemEmail;
    },
    resetNavBar() {
      const info = Vue.prototype.$userInfo;
      if (info != null) {
        this.title = info.companies[0].title;
        this.displayName = `${info.firstName} ${info.lastName}`;
        this.contact = info.companies[0].contactEmail;
        this.avatar = info.image;
      }
    },
    logout() {
      EventBus.$emit("signout");
    },
    onSearch() {
      if (this.mainSearch != "" && this.mainSearch != undefined) {
        let q = this.mainSearch;
        this.mobileSearch = false;
        // this.mainSearch = "";

        if (this.$route.name == "search") {
          EventBus.$emit("onSearchReload", q);
        } else {
          this.$router.push({
            name: "search",
            query: {
              q: q,
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.hoverable {
  max-height: 100%;
  width: auto;
  max-width: 100% !important;
}
.caption.text-primary {
  // color: rgba(0, 0, 0, 0.6)
  color: white;
}
.white-text {
  // color: rgba(0, 0, 0, 0.6)
  color: white;
}
.mobile-search {
  z-index: 99;
  top: 16px;
  left: 0px;
}
.no-padding {
  padding: 0px !important;
}
.max-width {
  max-width: 100%;
}
.search {
  .v-icon.v-icon {
    font-size: 18px;
    color: #c5c5c5;
  }
  &.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset {
    // border-color: rgba(0, 0, 0, 0.87);
    color: #c5c5c5;
  }
}
.text-right {
  text-align: right;
}
.black-text {
  color: black !important;
}

.list-menu {
  // .v-list-item--dense .v-list-item__title, .v-list-item--dense .v-list-item__subtitle, .v-list--dense .v-list-item .v-list-item__title, .v-list--dense .v-list-item .v-list-item__subtitle {
  //   font-weight: 400 !important;
  // }
  .v-list-item__title {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .v-icon.v-icon {
    font-size: 18px !important;
  }
}
.small-icon {
  font-weight: 300 !important;
}
.text-normal {
  font-weight: 400 !important;
}
@import "../scss/variables.scss";
</style>